import styled from 'styled-components'

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
`

export default Header
